<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" />

<div class="container" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="start center">
    <div class="breadcrumb">
      <p>
        <a [routerLink]="'/dashboard'" class="breadcrumb-link">Home</a> /
        <span>Advertisement</span>
      </p>
    </div>
  </div>

  <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100" fxFlex.xs="100" fxLayout.xs="column">
    <div class="search-bar" fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="50" fxFlex.xs="100" fxLayoutGap="10">
      <div fxLayout="row wrap" fxLayoutGap="5">
        <mat-form-field appearance="outline" class="mat-form-field">
          <mat-select placeholder="Filter Language" [(ngModel)]="selectedLanguage" (ngModelChange)="filterImages()">
            <mat-option value="en">English</mat-option>
            <mat-option value="fr">French</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="mat-form-field">
          <mat-select placeholder="Filter Image Type" [(ngModel)]="selectedImageType" (ngModelChange)="filterImages()">
            <mat-option value="banner">Banner</mat-option>
            <mat-option value="explorer">Explorer</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="search-bar" fxLayout="row wrap" fxLayoutAlign="end center" fxFlex="50" fxFlex.xs="100" fxLayoutGap="10">
      <div class="search-bar" fxFlex.xs="100">
        <div class="search-container">
          <input type="text" placeholder="Search for images" [(ngModel)]="searchQuery" (input)="searchImages()" class="search-input">
          <span class="search-icon"><i class="fas fa-search"></i></span>
        </div>
      </div>      

      <div class="view-options" fxLayout="row wrap" fxLayoutGap="10">
        <span class="list-view" [ngClass]="{'selected-view': currentView === 'list-view'}" (click)="viewType('list-view')">
          <i class="fas fa-list"></i>
        </span>
        <span class="grid-view" [ngClass]="{'selected-view': currentView === 'grid-view'}" (click)="viewType('grid-view')">
          <i class="fas fa-th-large"></i>
        </span>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="10" fxLayout.xs="column">
    <div class="uploading" fxFlex.xs="100">
      <div class="upload-container" (drop)="onFileDrop($event)" (dragover)="onFileOver($event)">
        <div *ngIf="!uploadedImage" class="upload" fxLayoutAlign="center" (click)="photoUpload()">
          <div fxLayout="column" fxLayoutAlign="center center">
            <span class="upload-icon"><i class="fas fa-cloud-upload-alt"></i></span>
            <p>Drop files here, or click to upload files</p>
            <input type="file" #fileInput (change)="onFileSelected($event)" hidden accept=".jpeg, .jpg, .png">
          </div>
        </div>
        <div *ngIf="uploadedImage" class="image-preview" fxLayoutAlign="center">
          <img [src]="uploadedImage" alt="Uploaded Image" class="uploaded-image">
        </div>
      </div>
      <div *ngIf="showProgress" class="progress-container">
        <div class="progress-info">
          <p class="fileName">{{ fileName }}</p>
          <span class="abort-upload" (click)="abortUpload()"><i class="fas fa-times abort"></i></span>
        </div>
        <div class="progress-info" fxLayout="row" fxLayoutAlign="space-between center">
          <mat-progress-bar mode="determinate" [value]="progress" fxFlex="85"></mat-progress-bar>
          <p>{{progress}}%</p>
        </div>
        <p>Uploading Image...</p>
      </div>
    </div>
    <div *ngIf="currentView === 'list-view'" class="image-container" fxFlex.xs="100" cdkDropList
      (cdkDropListDropped)="onImageDrop($event)">
      <div *ngFor="let image of filteredImageDataInfo; let i = index" class="list-item" cdkDrag
        (cdkDragStarted)="onDragStarted($event)">
        <div class="image-content">
          <button mat-icon-button [matMenuTriggerFor]="menu" class="menu-button-list">
            <i class="fas fa-ellipsis-v"></i>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="updateImage(image.image_url)">Update</button>
            <button mat-menu-item (click)="deleteImage(image.image_url)">Delete</button>
          </mat-menu>
          <img [src]="image.image_url" class="uploaded-image" (click)="viewImageDetails(image)">
          <div class="image-details-column">
            <p *ngIf="image.title" class="image-details">
              <span class="detail-label">Title:</span>
              <span class="detail-value">{{image.title}}</span>
            </p>
            <p *ngIf="image.description" class="image-details">
              <span class="detail-label">Description:</span>
              <span class="detail-value">{{image.description}}</span>
            </p>
            <p *ngIf="image.start_date" class="image-details">
              <span class="detail-label">Start Date:</span>
              <span class="detail-value">{{image.start_date | date :dateFormat }}</span>
            </p>
            <p *ngIf="image.end_date" class="image-details">
              <span class="detail-label">End Date:</span>
              <span class="detail-value">{{image.end_date | date :dateFormat}}</span>
            </p>
            <p *ngIf="image.button_text" class="image-details">
              <span class="detail-label">Button Text:</span>
              <span class="detail-value">{{image.button_text}}</span>
            </p>
            <p *ngIf="image.read_more_link" class="image-details">
              <span class="detail-label">Read More Link:</span>
              <a class="detail-link" [href]="image.read_more_link" target="_blank">{{image.read_more_link}}</a>
            </p>
            <p *ngIf="image.status" [ngClass]="getStatusClass(image.status)" class="image-details">
              <span class="detail-label">Status:</span>
              <span class="detail-value">{{image.status}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="currentView === 'grid-view'" class="grid-image-container" fxFlex.xs="100">
      <div *ngFor="let image of filteredImageDataInfo; let i = index" cdkDrag (cdkDragStarted)="onDragStarted($event)"
        class="grid-item">
        <button mat-icon-button [matMenuTriggerFor]="menu" class="menu-button">
          <i class="fas fa-ellipsis-v"></i>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="updateImage(image.image_url)">
            <span>Update</span>
          </button>
          <button mat-menu-item (click)="deleteImage(image.image_url)">
            <span>Delete</span>
          </button>
        </mat-menu>
        <img [src]="image.image_url" class="uploaded-image" (click)="viewImageDetails(image)">
        <p *ngIf="image.title" class="image-details-list">
          <span class="detail-label">Title:</span>
          <span class="detail-value">{{image.title}}</span>
        </p>
        <p *ngIf="image.start_date" class="image-details-list">
          <span class="detail-label">Start Date:</span>
          <span class="detail-value">{{image.start_date | date :dateFormat }}</span>
        </p>
        <p *ngIf="image.end_date" class="image-details-list">
          <span class="detail-label">End Date:</span>
          <span class="detail-value">{{image.end_date | date :dateFormat}}</span>
        </p>
        <p *ngIf="image.status" [ngClass]="getStatusClass(image.status)" class="image-details-list">
          <span class="detail-label">Status:</span>
          <span class="detail-value">{{image.status}}</span>
        </p>
      </div>
    </div>
    <div class="error-message" *ngIf="errorMessage">
      <p class="no-images">No Data to show</p>
    </div>
  </div>